import { afterRenderEffect, ChangeDetectionStrategy, Component, effect, ElementRef, input, signal, viewChild } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'ces-expandable-description',
  imports: [TranslocoModule],
  templateUrl: './expandable-description.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpandableDescriptionComponent {
  private readonly descriptionRef = viewChild<ElementRef<HTMLParagraphElement>>('descriptionText');

  readonly description = input.required<string>();

  protected readonly expanded = signal(false);
  protected readonly isOverflowing = signal(false);

  constructor() {
    effect(() => {
      this.description();
      this.expanded.set(false);
      this.isOverflowing.set(false);
    });

    afterRenderEffect({
      read: () => {
        this.description();
        const el = this.descriptionRef()?.nativeElement;
        if (el && !this.expanded()) {
          const overflows = el.scrollHeight > el.clientHeight;
          if (overflows !== this.isOverflowing()) {
            this.isOverflowing.set(overflows);
          }
        }
      },
    });
  }
}
